import { GUI } from "dat.gui";
import gsap from "gsap";
import { BoxGeometry, Mesh, MeshStandardMaterial } from "three";
// import { gsap } from "gsap";

export class CubeSelect extends Mesh {
	constructor(name = "", color = 0x99ff33, size = 1) {
		super();
		this.geometry = new BoxGeometry(size, size, size);
		const uploadMaterial = new MeshStandardMaterial({
			color: color,
		});
		uploadMaterial.transparent = true
		// uploadMaterial.emissive.set("#404040")
		this.material = uploadMaterial;
		this.name = `cube${name}`;
		this.renderOrder = 1;
		// this.scale.set(scale, scale, scale);
		// this.helpers();
	}

	entryAnimation() {
		// gsap.to(this.position, { y: this.axisY, duration: 0.8 });
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null;
		}

		if (this.animationEmessive) {
			this.animationEmessive.kill();
			this.animationEmessive = null;
			this.material.emissiveIntensity = 1
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.opacity = 0.8
			this.objectActiveAnimation = null
		}
	}

	onAnimateEmissive() {
		this.clearAnimation()

		this.animationEmessive = gsap.to(this.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimationOpacity() {
		this.clearAnimation()

		this.objectActiveAnimation = this

		// Creamos un objeto con la propiedad de opacidad para poder animarla
		const opacityObject = { opacity: 0.4 };

		// Animación de opacidad de 0.6 a 0.4 y viceversa en bucle
		this.animation = gsap.to(opacityObject, {
			opacity: 0.8,
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				// Actualizamos la opacidad del material en cada fotograma
				this.material.opacity = opacityObject.opacity;
			},
		});

	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder(this.name);
		premiaFolder.add(this.position, "x", -30, 30).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -30, 30).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -30, 30).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("Rotacion X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("Rotacion Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("Rotacion Z");
		premiaFolder.add(this.scale, "x", 0, 5).step(0.01).name("Escala X");
		premiaFolder.add(this.scale, "y", 0, 5).step(0.01).name("Escala Y");
		premiaFolder.add(this.scale, "z", 0, 5).step(0.01).name("Escala Z");
	}
}
